import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import {TypeDescMarche} from './TypeDescMarche';
import { TypeInfosRectif } from './TypeInfosRectif';
import { TypeLieu } from './TypeLieu';
export class Rectificatif {

	public infosRectif: TypeInfosRectif[];

	public avisInitial: AvisInitialTypeLight;

	public description: TypeDescMarche;

	public typeProcedure: string;

	public objet: string;
	
	public lieuExecutionLivraison: TypeLieu;

	public lieuExecution: TypeLieu;

	public lieuLivraison: TypeLieu;

	constructor() { 
		this.infosRectif = [];
		this.description = new TypeDescMarche();
		this.typeProcedure = '';
		this.objet = '';
		this.lieuLivraison = new TypeLieu();
		this.lieuExecutionLivraison = new TypeLieu();
		this.lieuExecution = new TypeLieu();
	}
}
